import firebase from 'firebase/app';
import db from '../firebaseInit';
import {IS_LOGGING} from './../constants/activityLogs';

const logUserActivity = (message, callbackFunc = null) => {
  if (!IS_LOGGING) return;
  const user = firebase.auth().currentUser;
  const unixTimestampMs = Date.now().toString();
  db.collection('userActivityLogs')
    .doc(unixTimestampMs)
    .set({
      activity: message,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      unixTimestampMs: unixTimestampMs,
      unixTimestampSec: Math.floor(unixTimestampMs / 1000).toString(),
      userId: user.uid,
    })
    .then(function(documentData) {
      if (callbackFunc) {
        callbackFunc();
      }
    })
    .catch(function(error) {
      // console.error('Error adding user activity log: ', error);
      if (callbackFunc) {
        callbackFunc();
      }
    });
};

export default logUserActivity;
